import { Button, Form, FormInstance, Input, Modal, Space } from "antd";
import React, { useEffect } from "react";
import { CreateHallPayload, UpdateHallPayload } from "../../interfaces";
import TextArea from "antd/lib/input/TextArea";
import { useDispatch } from "react-redux";
import { getHall } from "../../store/halls";
import { appSelector } from "../../helpers/appSelector";
import { ModalSpinner, Spinner } from "../common/Spinner";

interface Props {
  open: boolean;
  onCancel: () => void;
  form: FormInstance<UpdateHallPayload>;
  onFinish: ((values: UpdateHallPayload) => void) | undefined;
  id: string;
  schoolId?: string | number;
}

const UpdateHallForm = ({
  open,
  onCancel,
  form,
  onFinish,
  id,
  schoolId,
}: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    id && dispatch(getHall(id));
  }, [id]);

  const {
    hall,
    loading: loadingHall,
    isHallSubmitting,
    success,
  } = appSelector((state) => state.hallsStore);

  useEffect(() => {
    success && onCancel();
  }, [success]);

  const initialValues: UpdateHallPayload = {
    name: hall?.name || "",
    contact: hall?.contact || "",
    description: hall?.description || "",
    school_id: schoolId?.toString() || "",
    id: hall?.id || "",
  };

  form.setFieldsValue(initialValues);

  return (
    <Modal
      title="Add Hall"
      open={open}
      onCancel={onCancel}
      footer={[
        <Button type="default" key="cancel" onClick={() => onCancel()}>
          Close
        </Button>,
        <Button
          form="hallUpdateForm"
          key="submit"
          htmlType="submit"
          type="primary"
          loading={isHallSubmitting}
        >
          {isHallSubmitting ? "Updating.." : "Update"}
        </Button>,
      ]}
    >
      <Form<UpdateHallPayload>
        form={form}
        layout="vertical"
        id="hallUpdateForm"
        name="hallUpdateForm"
        initialValues={initialValues}
        onFinish={onFinish}
      >
        {loadingHall ? (
          <ModalSpinner />
        ) : (
          <>
            <Form.Item
              name="name"
              label="Hall Name"
              rules={[
                {
                  required: true,
                  message: "Please input the name of the hall!",
                },
              ]}
            >
              <Input type="text" />
            </Form.Item>
            <Form.Item name="contact" label="Contact">
              <Input maxLength={10} showCount type="tel" />
            </Form.Item>
            <Form.Item name="description">
              <TextArea allowClear rows={5} />
            </Form.Item>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default UpdateHallForm;
